import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SubmissionsService } from 'src/app/services/submissions.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-ai-score-distribution',
    templateUrl: './ai-score-distribution.component.html',
    styleUrls: ['./ai-score-distribution.component.scss']
})
export class AiScoreDistributionComponent implements OnInit, OnChanges {
    @Input() isProfessor: boolean = false;
    @Input() filterType: string;

    constructor(private submissionsService: SubmissionsService, private translate: TranslateService) { }

    years: number[] = [];
    selectedYear: number;
    series = [{
        name: 'AI flagged',
        data: [2, 5, 12, 20, 35, 60, 95, 75, 68, 50, 30, 0]
    }];
    chart = {
        type: 'bar',
        height: 500,
        width: "100%"
    };
    xaxis = { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] };
    yaxis = { min: 0, max: 100, tickAmount: 5 };
    plotOptions = {
        bar: {
            columnWidth: '100%', borderRadius: 6, borderWidth: 2,
            borderColor: '#000'
        }
    };
    dataLabels = { enabled: false };
    colors = ['#8e7cf4'];
    ngOnInit() {
        const currentYear = new Date().getFullYear();
        this.years = Array.from({ length: 5 }, (_, i) => currentYear - i).reverse();
        this.selectedYear = currentYear;

        this.loadAiDetectionData(this.selectedYear);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['filterType'] && !changes['filterType'].firstChange) {
            this.loadAiDetectionData(this.selectedYear);
        }
    }

    loadAiDetectionData(year: number): void {
        this.submissionsService.getAiDetectionSubmissions(year.toString(), this.isProfessor, undefined, undefined, undefined, this.filterType).subscribe(
            response => {
                console.log(response);

                const aiDetection: number[] = response.aiDetection.map(Number);

                this.series = [{
                    name: this.translate.instant('new_entries.ai_detection'),
                    data: aiDetection
                }];
            },
            error => {
                console.error('Failed to fetch AI detection data', error);
            }
        );
    }

    onYearChange(year: number) {
        this.selectedYear = year;
        this.loadAiDetectionData(year);
    }


} 